<template>
  <div class="home">
    <b-container fluid>
      <b-row>
        <b-col cols="12" class="p-0">
          <TopBarMember />
        </b-col>
        <b-col cols="12">
          <b-container class="px-0 px-sm-3">
            <b-row>
              <b-col cols="12" class="d-lg-none d-xl-none">
                <TopJackpot />
              </b-col>
              <b-col cols="12">
                <TopCredit />
              </b-col>
              <b-col cols="12">
                <TopMarquee />
                <TopMenuMember />
              </b-col>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import TopBarMember from "@/components/TopBarMember.vue";
import TopJackpot from "@/components/TopJackpot.vue";
import TopCredit from "@/components/TopCredit.vue";
import TopMarquee from "@/components/TopMarquee.vue";
import TopMenuMember from "@/components/TopMenuMember.vue";

// @Component({
//   components: {
//     TopBarMember,
//     TopJackpot,
//     TopCredit,
//     TopMarquee,
//     TopMenuMember
//   }
// })
export default {
  name: "Member",
  data() {
    return {
      accessToken: this.accessToken,
    }
  },
  components: {
    TopBarMember,
    TopJackpot,
    TopCredit,
    TopMarquee,
    TopMenuMember
  }
}
</script>
